// ⚙️ «Hozir serverni nima band qilyapti» — 🖥 Serverlar flyout'i ichida (2026-10-27, docs/knowledge/187).
// Backend `/server/activity`: jarayonlar 1 s oynada o'lchanib ishlarga yig'iladi (build / emulator / AI agent /
// brauzer / test-muhit / yetim Gradle daemon…) + mobil build navbati (ketyapti / navbatda / navbatdan tashqari).
// Flyout OCHIQ turgandagina so'raladi (komponent faqat ochiq panelda chiziladi), 10 s da yangilanadi.
import React from 'react';

const fmtDur = (s) => {
  if (s == null) return '';
  if (s < 60) return `${s} s`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m} daq`;
  const h = Math.floor(m / 60);
  if (h < 48) return m % 60 ? `${h} soat ${m % 60} daq` : `${h} soat`;
  return `${Math.floor(h / 24)} kun`;
};
const fmtRam = (mb) => (mb >= 1024 ? `${(mb / 1024).toFixed(1)} GB` : `${mb} MB`);
// Nomlar (loyiha/modul/foydalanuvchi) runtime tarjimonga berilmaydi.
const NAMED = new Set(['build', 'emu', 'agent', 'testenv']);

const STATE = {
  running: { t: '▶ ketyapti', cls: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-400', tip: 'Navbat orqali qurilyapti' },
  outside: { t: '⚠️ navbatdan tashqari', cls: 'bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-400',
    tip: "Bu build navbat reestrida yo'q — navbatni chetlab, boshqa build bilan parallel qurilyapti (masalan qo'lda ishga tushirilgan skript)" },
  booting: { t: '⏳ ishga tushmoqda', cls: 'bg-primary-100 text-primary-800 dark:bg-primary-900/50 dark:text-primary-300', tip: 'Emulator yuklanmoqda' },
};

export default function ServerActivity({ authFetch, apiUrl }) {
  const [data, setData] = React.useState(null);
  const [err, setErr] = React.useState('');
  // authFetch har render'da yangi identity — effekt dep'iga qo'yilmaydi (refetch-storm).
  const afRef = React.useRef(authFetch);
  afRef.current = authFetch;

  React.useEffect(() => {
    let alive = true;
    const load = () => afRef.current(`${apiUrl}/server/activity`)
      .then(async (r) => {
        const d = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(d.error || `HTTP ${r.status}`);
        return d;
      })
      .then((d) => { if (alive) { setData(d); setErr(''); } })
      .catch((e) => { if (alive) setErr(String(e.message || e)); });
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 10000);
    return () => { alive = false; clearInterval(t); };
  }, [apiUrl]);

  const box = 'rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 p-3';
  if (!data) {
    return (
      <div className={box}>
        <div className="text-sm font-semibold text-gray-900 dark:text-white mb-1">⚙️ Hozir nima band qilyapti</div>
        <div className="text-[11px] text-gray-500 dark:text-gray-400">{err ? `⚠️ ${err}` : "⏳ Jarayonlar o'lchanmoqda…"}</div>
      </div>
    );
  }

  const jobs = data.jobs || [];
  const queue = data.queue || [];
  const builds = jobs.filter(j => j.kind === 'build');
  return (
    <div className={box}>
      <div className="flex items-baseline justify-between mb-2 gap-2">
        <span className="text-sm font-semibold text-gray-900 dark:text-white">⚙️ Hozir nima band qilyapti</span>
        <span className="text-[10px] text-gray-400 shrink-0" title={`CPU — butun serverning ulushi (${data.ncpu} yadro = 100%), ${data.windowSec} s oynada o'lchanadi; 10 s da yangilanadi`}>
          CPU · RAM
        </span>
      </div>

      <div className="space-y-2">
        {jobs.map(j => {
          const st = j.state && STATE[j.state];
          const sub = [j.detail, j.since != null ? fmtDur(j.since) : null].filter(Boolean).join(' · ');
          return (
            <div key={j.key} title={`${j.cores} yadro · ${j.procs} jarayon`}>
              <div className="flex items-start justify-between gap-2 text-[11px]">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1 flex-wrap">
                    <span className="shrink-0">{j.icon}</span>
                    <span className="text-gray-800 dark:text-gray-200 font-medium truncate" translate={NAMED.has(j.kind) ? 'no' : undefined}>{j.label}</span>
                    {st && <span className={`text-[9px] px-1.5 py-0.5 rounded font-semibold ${st.cls}`} title={st.tip}>{st.t}</span>}
                  </div>
                  {sub && <div className={`text-[10px] ${j.kind === 'gdaemon' ? 'text-amber-600 dark:text-amber-400' : 'text-gray-500 dark:text-gray-400'}`}>{sub}</div>}
                </div>
                <div className="text-right font-mono shrink-0">
                  <div className="text-gray-700 dark:text-gray-300">{j.cpu}%</div>
                  <div className="text-[10px] text-gray-400">{j.ramMB ? fmtRam(j.ramMB) : ''}</div>
                </div>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-1 overflow-hidden mt-0.5">
                <div className={`h-1 rounded-full ${j.cpu > 40 ? 'bg-red-500' : j.cpu > 15 ? 'bg-yellow-500' : 'bg-primary-600'}`}
                  style={{ width: `${Math.min(100, j.cpu)}%` }} />
              </div>
            </div>
          );
        })}
        {data.rest && data.rest.n > 0 && (
          <div className="flex justify-between text-[10px] text-gray-500 dark:text-gray-400">
            <span>Boshqa {data.rest.n} ta jarayon guruhi</span>
            <span className="font-mono">{data.rest.cpu}% · {fmtRam(data.rest.ramMB)}</span>
          </div>
        )}
      </div>

      <div className="mt-3 pt-2 border-t border-gray-200 dark:border-gray-600 text-[11px]">
        <div className="font-semibold text-gray-800 dark:text-gray-200 mb-1">
          🔨 Mobil build navbati <span className="font-normal text-gray-500 dark:text-gray-400">· bir vaqtda {data.buildSlots || 1} ta</span>
        </div>
        {!builds.length && !queue.length && <div className="text-gray-500 dark:text-gray-400">Hozir build yo'q, navbat bo'sh</div>}
        {builds.length > (data.buildSlots || 1) && (
          <div className="text-amber-600 dark:text-amber-400 mb-1">⚠️ {builds.length} ta build parallel ketyapti — server sekinlashadi</div>
        )}
        {queue.map(q => (
          <div key={q.id} className="flex justify-between gap-2">
            <span className="min-w-0">
              ⏳ <span translate="no">{q.label}</span>
              <span className="block text-[10px] text-gray-500 dark:text-gray-400">
                {[q.detail, q.reason === 'module' ? "shu modulning boshqa build'i tugashini kutyapti" : q.reason === 'slot' ? 'server band — navbatda' : 'navbatga turdi'].filter(Boolean).join(' · ')}
              </span>
            </span>
            <span className="font-mono text-gray-500 dark:text-gray-400 shrink-0">{fmtDur(q.waitSec)}</span>
          </div>
        ))}
      </div>
      {err && <div className="mt-1 text-[10px] text-amber-600 dark:text-amber-400">⚠️ Yangilab bo'lmadi: {err}</div>}
    </div>
  );
}
